import { ReactNode, useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAccount } from '@/hooks/use-account';
import { AccountDto } from '@/api-client/autogenerated';

type PortalKey = keyof Pick<AccountDto, 'lobbyistPortal' | 'analystPortal' | 'clientCrm'>;

interface PortalGuardProps {
  portal: PortalKey;
  children: ReactNode;
}

export function PortalGuard({ portal, children }: PortalGuardProps) {
  const { selectedAccount } = useAccount();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (selectedAccount && !selectedAccount[portal]) {
      navigate('/dashboard');
    }
  }, [selectedAccount, portal, navigate]);

  return <>{children}</>;
}
